import { Panel, Typography } from "@/components/atoms";
import { useViewVehicleContext } from "../../context";
import { UploadVehicleDocument } from "./UploadVehicleDocument";
import { VehicleDocumentCard } from "./VehicleDocumentCard";

export const VehicleDocuments = () => {
  const {
    vehicle: {
      uuid,
      documents: allDocuments,
      metadata: { isArchived },
    },
    isLegacy,
  } = useViewVehicleContext();

  const documents = allDocuments.filter((doc) => doc.documentType === "OTHER");
  const isReadOnly = isArchived || isLegacy;

  if (isReadOnly && documents.length === 0) return null;

  return (
    <Panel>
      <div className="mb-5">
        <Typography variant="h3">Additional Files</Typography>
        <Typography className="text-neutral-dark-gray">
          {isReadOnly ? "Documents associated with this vehicle" : "Upload any documents related to this vehicle"}
        </Typography>
      </div>
      <div className="flex flex-wrap gap-3">
        {documents.map((document) => (
          <VehicleDocumentCard key={document.uuid} document={document} vehicleId={uuid} isReadOnly={isReadOnly} />
        ))}
        {!isReadOnly && <UploadVehicleDocument />}
      </div>
    </Panel>
  );
};
